import moment from 'moment';
import React from 'react';
import { useTable } from 'react-table';
import styled from 'styled-components';

import useAPI from '@hooks/useAPI';
import Spinner from '@shared/Spinner';

const listAccessor = ({
  screen_type,
  rule_name,
  updatedAt,
  created_at,
  rule_description,
}) => ({
  description: rule_description,
  ruleType: screen_type,
  label: rule_name,
  updatedAt,
  created_at,
});

const FullWidthContainer = styled.div`
  width: 100%;
`;
const FullWidthTable = styled.table`
  width: 100%;
`;
const TableBodyContainer = styled.tbody``;
const Row = styled.tr`
  :not(:last-child) {
    border-bottom: ${props => props.theme.borderMd};
  }
`;
const CellContainer = styled.td`
  padding: 15px 0px 10px 0px;
  vertical-align: middle;
`;

const Spacer = styled.span`
  border-left: ${props => props.theme.borderMd};
  height: 20px;
  padding: 0px 10px;
`;

const TypeCell = styled.span`
  text-transform: uppercase;
  color: ${props => props.theme.primary};
  font-size: ${props => props.theme.font.fontSm};
`;

const AboveLabel = styled.span`
  font-size: ${props => props.theme.font.fontSm};
  color: ${props => props.theme.fontTertiary};
  text-transform: capitalize;
`;

const Label = styled.span`
  line-height: 24px;
  color: ${props => props.theme.primary};
`;

export default function RulesTable() {
  const screenConfig = useAPI('get', 'ScreenConsoleApi', `config`);
  const { isLoading } = screenConfig;
  const data = screenConfig?.response?.config_screen?.rules || [];
  const hasResults = data && data.length;

  const columns = [
    {
      Header: 'List Name',
      Cell: ({ cell: { value } }) => (
        <span>
          <AboveLabel>
            Last Updated{' '}
            {moment(value.updatedAt || value.created_at).format('MM/DD/YYYY')}
            <br />
          </AboveLabel>
          <Label>{value.label}</Label>
          <br />
          <AboveLabel>
            {value.ruleType} - {value.description}
          </AboveLabel>
        </span>
      ),
      accessor: listAccessor,
    },
    {
      Header: 'Spacer',
      Cell: () => <Spacer />,
    },
    {
      Header: 'Type',
      Cell: ({ cell: { value } }) => <TypeCell>{value}</TypeCell>,
      accessor: 'screen_type',
    },
  ];

  const { getTableProps, getTableBodyProps, rows, prepareRow } = useTable({
    columns: React.useMemo(() => columns, []),
    data: React.useMemo(() => data, [data]),
  });

  if (hasResults) {
    return (
      <FullWidthTable {...getTableProps()}>
        <TableBodyContainer {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <Row {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return (
                    <CellContainer {...cell.getCellProps()}>
                      {cell.render('Cell')}
                    </CellContainer>
                  );
                })}
              </Row>
            );
          })}
        </TableBodyContainer>
      </FullWidthTable>
    );
  }

  if (!isLoading && !hasResults) {
    return (
      <div>
        No configuration present. Please contact{' '}
        <a href='mailto:screen-support@enigma.com'>screen-support@enigma.com</a>{' '}
        to update your configuration.
      </div>
    );
  }

  return (
    <FullWidthContainer>
      <Spinner center />
    </FullWidthContainer>
  );
}
